import { getIdFromCountry } from "#utils/country_utils";
import { PayeeBaseAddress } from "../../../types";
import { PayeeVendorTaxDocument, TaxDocumentType } from "../../types";
import { TaxFormType } from "./constants";
import { VendorPayeeDetailsFields } from "./types";

const getFormTypeFromDocumentType = (documentType: TaxDocumentType): TaxFormType => {
  return documentType === TaxDocumentType.US_TAX ? TaxFormType.W9 : TaxFormType.W8;
};

export const shouldDispatchPayeeDetails = (
  formValues: VendorPayeeDetailsFields,
  payeeName?: string,
  payeeAddress?: PayeeBaseAddress,
  form1099Required?: string,
  taxDocuments?: PayeeVendorTaxDocument[],
  taxCountryId?: string,
  taxId?: string,
) => {
  // If the payee name is not set then dispatch must be called since it is required for creating a payee.
  if (!payeeName) {
    return true;
  }

  // Check if tax form has changed
  const currentTaxFormType =
    taxDocuments && taxDocuments.length > 0
      ? getFormTypeFromDocumentType(taxDocuments[0].documentType)
      : undefined;
  const hasTaxFormChanged = formValues.taxFormType !== currentTaxFormType;

  // If any of the form values have changed then dispatch must be called.
  return (
    formValues.payeeName !== payeeName ||
    formValues.country !== payeeAddress?.countryId ||
    formValues.state !== payeeAddress?.stateId ||
    formValues.province !== payeeAddress?.region ||
    formValues.streetLine1 !== payeeAddress?.street ||
    formValues.streetLine2 !== payeeAddress?.street2 ||
    formValues.city !== payeeAddress?.city ||
    formValues.zip !== payeeAddress?.postalCode ||
    formValues.form1099Required !== form1099Required ||
    getIdFromCountry(formValues.taxCountryId) !== (taxCountryId || "") ||
    (formValues.taxId || "") !== (taxId || "") ||
    hasTaxFormChanged
  );
};
